import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
  },
  actions: {
  },
  getters: {
  }
}
